export default {
    init: function () {
        // JavaScript to be fired on all pages

        // Jquery-match-height
        $(function () {
            setTimeout(function () {
                $('.match-height').matchHeight();
            }, 500);
        });


        // Team slider
        $('.team__slider').slick({
            dots: false,
            arrows: true,
            infinite: false,
            autoplay: true,
            autoplaySpeed: 8000,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });

        // Team slider
        $('.sponsor__slider').slick({
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            slidesToShow: 7,
            slidesToScroll: 1,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
            ],
        });

        // $(document).ready(function() {
        //     $(".fancybox").fancybox();
        // });

        $('.slick-slider').css('opacity', '1');

        $(window).scroll(function () {
            var scroll = $(window).scrollTop();
            if (scroll > 100) {
                $('.header').addClass('header__scroll');
            } else {
                $('.header').removeClass('header__scroll');
            }
        });

        $(function () {
            $('.js-splash-close').on('click', function () {
                $('.front__main, .front__footer, .front__header').css('filter', 'none');
                $('.splashscreen').css('display', 'none');
                $('.body__blur').css('filter', 'blur(0px)');
                $.cookie('splashscreen', true, {expires: 365, path: '/'});
            });

        });

        $(document).ready(function () {
            let accordionContainers = $('.flexible__accordion');

            accordionContainers.each(function () {
                let container = $(this);
                let accordionItems = container.find('.flexible__accordion__border');
                let active = false;
                let alwaysOpen = container.is('[data-multiple-open]');
                let firstItemOpen = container.is('[data-first-item-open]');

                accordionItems.each(function (index) {
                    let item = $(this);
                    let button = item.find('.flexible__accordion__button');
                    let content = item.find('.flexible__accordion__content');
                    let arrow = button.find('.flexible__accordion__button__arrow');

                    button.on('click', function () {
                        let expanded = button.attr('aria-expanded') === 'true';

                        // Toggle expanded state
                        button.attr('aria-expanded', !expanded);
                        content.css('maxHeight', expanded ? '0' : content[0].scrollHeight + 'px');
                        arrow.css('transform', expanded ? 'none' : 'rotate(180deg)');

                        if (!expanded) {
                            content.on('transitionend', function () {
                                $('html, body').animate({
                                    scrollTop: item.offset().top - 170,
                                }, 300);

                                content.off('transitionend');
                            });
                        }

                        // Update active state
                        active = !expanded ? index : false;

                        // Close other accordion items if alwaysOpen is not set
                        if (!alwaysOpen) {
                            accordionItems.each(function (otherIndex) {
                                if (otherIndex !== index) {
                                    let otherItem = $(this);
                                    let otherButton = otherItem.find('.flexible__accordion__button');
                                    let otherContent = otherItem.find('.flexible__accordion__content');
                                    let otherArrow = otherButton.find('.flexible__accordion__button__arrow');

                                    otherButton.attr('aria-expanded', false);
                                    otherContent.css('maxHeight', '0');
                                    otherArrow.css('transform', 'none');
                                }
                            });
                        }
                    });

                    // Set initial state
                    if (firstItemOpen && index === 0) {
                        button.attr('aria-expanded', true);
                        content.css('maxHeight', content[0].scrollHeight + 'px');
                        arrow.css('transform', 'rotate(180deg)');
                    } else {
                        button.attr('aria-expanded', index === active);
                        content.css('maxHeight', index === active ? content[0].scrollHeight + 'px' : '0');
                        arrow.css('transform', index === active ? 'rotate(180deg)' : 'none');
                    }
                });
            });
        });
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
